<template>
	<div :class="tabIndex == 0 ? 'bg-w' : 'bg-F3F3F3'">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="sc-container body-height py-5" >
			<div class="d-flex flex-wrap align-items-center">
				<div class="d-flex align-items-center clickAct pe-4" v-for="(item,index) in list"
				:class="index==tabIndex? 'cl-theme ftw600':'cl-info'" @click="tabIndex=index">
					<div class="iconfont  ftr-1-5 mr5" :class="item.icon" ></div>
					{{item.name}}
				</div>
			</div>
			<div class="pt-4">
				<div v-if="tabIndex==0">
					<user-center @select="changeTabIndex"></user-center>
				</div>
				<div v-else-if="tabIndex==1">
					<my-class @select="changeTabIndex"></my-class>
				</div>
				<div v-else-if="tabIndex==2">
					<my-notes></my-notes>
				</div>
				<div v-else-if="tabIndex==3">
					<my-homework></my-homework>
				</div>
				<div v-else-if="tabIndex==4">
					<my-test></my-test>
				</div>
				<div v-else-if="tabIndex==5">
					<study-report></study-report>
				</div>
				<div v-else-if="tabIndex==6">
					<myTeacher></myTeacher>
				</div>
				<div v-else-if="tabIndex==7">
					<myWallet></myWallet>
				</div>
				<div v-else-if="tabIndex==8">
					<tradingOrder></tradingOrder>
				</div>
				<div v-else-if="tabIndex==9">
					<my-setting></my-setting>
				</div>
			</div>
		</div>
		<footers></footers>
	</div>
</template>

<script>
	import userCenter from './components/userCenter.vue'
	import myClass from './components/myClass.vue'
	import myNotes from './components/myNotes.vue'
	import myHomework from './components/myHomework.vue'
	import myTest from './components/myTest.vue'
	import studyReport from './components/studyReport.vue'
	import myTeacher from './components/myTeacher.vue'
	import myWallet from './components/myWallet.vue'
	import tradingOrder from './components/tradingOrder.vue'
	import mySetting from './components/mySetting.vue'
	
	export default{
		components:{
			userCenter,
			myClass,
			myNotes,
			myHomework,
			myTest,
			studyReport,
			myTeacher,
			myWallet,
			tradingOrder,
			mySetting
		},
		data(){
			return{
				tabIndex:0,
				list:[
					{
						name:this.$t('common.userCenter'),
						icon:'icon-xueshengzongshu'
					},
					{
						name:this.$t('teacherVue.myClass'),
						icon:'icon-chuangjiangongkaike'
					},
					{
						name:this.$t('studentsCom.myNotes'),
						icon:'icon-gongzuofankui'
					},
					{
						name:this.$t('studentsCom.myWork'),
						icon:'icon-zuizhongbaogao_yingyangyuansu'
					},
					{
						name:this.$t('studentsCom.myTest'),
						icon:'icon-tongji'
					},
					{
						name:this.$t('userCenter.learningReport'),
						icon:'icon-shuju'
					},
					{
						name:this.$t('studentsCom.myTeacher'),
						icon:'icon-yonghu'
					},
					{
						name:this.$t('userMyWallet.myWallet'),
						icon:'icon-qianbao'
					},
					{
						name:this.$t('studentsCom.tradingOrder'),
						icon:'icon-dingdan1'
					},
					{
						name:this.$t('common.setting'),
						icon:'icon-shezhi'
					}
				]
			}
		},
		 watch: {
		    // 监听$route对象
		    $route(to, from) {
		      // console.log('路由变化了');
		      // console.log('从:', from.fullPath, '到:', to.fullPath);
		      
		      // 在这里执行你的逻辑
			   // 创建 URL 对象
			    let parsedUrl1 = new URL(from.fullPath, window.location.origin);
			    let parsedUrl2 = new URL(to.fullPath, window.location.origin);
			    
			    // 获取 searchParams
			    let params1 = new URLSearchParams(parsedUrl1.search);
			    let params2 = new URLSearchParams(parsedUrl2.search);
			    
			    // 获取 index 值
			    let index1 = parseInt(params1.get('index'), 10);
			    let index2 = parseInt(params2.get('index'), 10);
			    
			    // 比较并返回最新的 index
			    index1 !== index2 ? this.tabIndex=index2 : this.tabIndex=index1;
		    }
		  },
		created(){
			this.$route.query.index?this.tabIndex=this.$route.query.index:''
		},
		methods:{
			changeTabIndex(e){
				this.tabIndex = e
				console.log('--------this.tabIndex',this.tabIndex);
			}
		}
	}
</script>

<style>
	@media (max-width:575.98px) {
		.sc-container {
			margin: auto;
			width: 100%;
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}
		
	}
	@media (min-width: 576px) {
		.sc-container {
			margin: auto;
			width: 580px;
		}
	
	}
	
	@media (min-width: 768px) {
		.sc-container {
			margin: auto;
			width: 700px;
		}
	}
	@media (min-width: 992px) {
		.sc-container {
			margin: auto;
			width: 900px;
		}
	}
	@media (min-width: 1200px) {
		.sc-container {
			margin: auto;
			width: 1100px;
		}
	}
	
	@media (min-width: 1400px) {
		.sc-container {
			margin: auto;
			width: 1300px;
		}
	}
</style>